const toStandardizedString = (string) => {
  return string.trim().toLowerCase();
};

export default toStandardizedString;
